import { authorizedFetch } from '../../utils/api';

const BASE = '/api/personalize/invest';
const ADMIN_BASE = '/api/personalize/control';

export const portfolioApi = {
  getPortfolios() {
    return authorizedFetch(`${BASE}/portfolios`);
  },

  getPositions(portfolioId) {
    return authorizedFetch(`${BASE}/portfolios/${portfolioId}/positions`);
  },

  getActivePositions() {
    return authorizedFetch(`${BASE}/portfolios/positions/active`);
  },

  syncPositions(userId) {
    return authorizedFetch(`${ADMIN_BASE}/brokerage-position/sync/${userId}`, {
      method: 'POST',
    });
  },
};
